module.exports = __webpack_public_path__ + "static/media/traveler.970abb61.webp";